<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-01 15:22:48
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-17 11:31:48
-->
<template>
  <van-popup round v-model="show" :close-on-click-overlay="false">
      <div class="agreement-style">
          <div class="agreement-title">温馨提示</div>
          <div class="agreement-text">您好，为了切实保护用户权益，我们根据业务开展的实际情况和相关法律更新了
                <span v-for="(item,index) in agreement" :key="index" class="base-color" @click="goAgreement(item.typeCode)">《{{item.name}}》</span>
           </div>
      </div>
      <div class="agreement-button base-color" @click="submit">同意并继续</div>
      <div class="agreement-button" @click="close">不同意并返回首页</div>
  </van-popup>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    props:{
        value:{
            type:Boolean,
            default:false
        }
    },
    computed:{
        ...mapGetters(['agreement','userInfo']),
        show:{
            get(){
                return this.value
            },
            set(val){
                this.$emit('input')
            }
        }
    },
    methods:{
        submit(){
            this.api.agreement.signAgreement({
                models:this.agreement.map(v=>({
                    agreementId:v.id,
                    userId:this.userInfo.id,
                    agreementTypeCode:v.typeCode,
                    agreementVersion:v.version,
                    userType:2
                }))
            }).then(({data})=>{
                this.show = false
            })
        },
        goAgreement(type){
            this.$router.push({
                path:`/agreement/detail/${type}`
            })
        },
        close(){
             WeixinJSBridge.call('closeWindow');
        }
    }
}
</script>

<style>
.agreement-style{
    padding:6.4vw 4.2vw;
    width: 74vw;
}
.agreement-title{
    font-size: 4.5vw;
    font-weight: bold;
    color: #12141A;
    text-align: center;
}
.agreement-text{
    margin-top: 3.7vw;
    font-size: 3.7vw;
    color: #60646B;
    line-height: 5.8vw;
}
.agreement-button{
    font-size: 4.2vw;
    font-weight: bold;
    text-align: center;
    padding:4.2vw 0;
    color: #43464D;
    border-top: 1px solid #EEEEEE;
}
</style>


// WEBPACK FOOTER //
// src/views/dialog/agreement.vue